import { glsDecodeToken, glsResolveAccountId, GlsTokenClaims } from '@gls-its-frontends/common/gls-auth';
import { defineStore } from 'pinia';
import { computed, ComputedRef, type Ref, ref } from 'vue';
import { Privilege } from '@/enums/privilege';
import Role from '@/enums/role';

type TokenClaims = GlsTokenClaims & { roles: Role[] };

const mainStoreKey: string = 'main';

const mainStore = defineStore(mainStoreKey, () => {
    const accessToken: Ref<string | null> = ref(null);
    const username: Ref<string | null> = ref(null);
    const userRoles: Ref<Role[]> = ref([]);
    const privileges: Ref<Privilege[]> = ref([]);
    const privilegesFailed: Ref<boolean> = ref(false);

    const setAccessToken = (token: string): void => {
        accessToken.value = token;
        const decodedUserToken: TokenClaims = glsDecodeToken(token) as TokenClaims;
        userRoles.value = decodedUserToken.roles;
    };

    const setUsername = (name: string): void => {
        username.value = name;
    };

    const setPrivileges = (userPrivileges?: Privilege[]): void => {
        privileges.value = userPrivileges?.length ? [...userPrivileges] : [];
    };

    const setPrivilegesFailure = (failure: boolean): void => {
        privilegesFailed.value = failure;
    };

    const claims: ComputedRef<GlsTokenClaims | null> = computed((): GlsTokenClaims | null => {
        if (!accessToken.value) {
            return null;
        }

        return glsDecodeToken(accessToken.value);
    });

    const oid: ComputedRef<string | null> = computed((): string | null => {
        if (!claims.value) {
            return null;
        }

        return glsResolveAccountId(claims.value);
    });

    return {
        accessToken,
        setAccessToken,
        setUsername,
        username,
        userRoles,
        privileges,
        privilegesFailed,
        setPrivileges,
        setPrivilegesFailure,
        oid,
        claims
    };
});

export default mainStore;
